import styled, { css } from 'styled-components';
import {toRem} from "shared/helpers";

export const Wrapper = styled.div<{$collapsed?: boolean}>`
    margin-bottom: 12px;
    cursor: pointer!important;
    
    * {
        cursor: pointer!important;
    }
    
    .input {
        margin-top: 0;
    }

    .input.input--primary .input__suffix svg, .input.input--primary .input__prefix svg {
        fill: none;
    }

    ${({$collapsed}) =>
            $collapsed ? css`width: 100%; 
                .input{min-width: 40px!important; max-width: 40px!important;} 
                .input__field{display: none!important;}
                .input.input--size-s.input--icon-prefix .input__prefix {left: 8px;}
                .input.input--size-s.input--icon-suffix .input__suffix {right: 0;}
            
            ` : css``
    }

    @media (width < ${toRem(768)}){
        .input {
            height: ${toRem(36)};
        }
    }
`
